module.exports = __webpack_public_path__ + "img/104.2aecbb4a.jpg";